import { motion, useInView, useMotionValue, animate } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export interface MetricCardProps {
  title: string;
  value: number;
  totalSize?: number;
  latestUpload?: string;
  icon: React.ComponentType<{ className?: string }>;
  folder: string;
}

function formatBytes(bytes: number) {
  if (bytes === 0) return '0 KB';
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  return `${(kb / 1024).toFixed(2)} MB`;
}

export default function MetricCard({
  title,
  value,
  totalSize,
  latestUpload,
  icon: Icon,
  folder,
}: MetricCardProps) {
  const navigate = useNavigate();

  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const motionValue = useMotionValue(0);
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    if (!isInView) return;

    const controls = animate(motionValue, value, {
      duration: 0.3,
      ease: 'easeOut',
      onUpdate: (latest) => {
        setDisplayValue(Math.floor(latest));
      },
    });

    return () => controls.stop();
  }, [isInView, value, motionValue]);

  return (
    <motion.div ref={ref}>
      <Card
        onClick={() => navigate(`/file-history?folder=${folder}`)}
        className="cursor-pointer hover:shadow-xl hover:-translate-y-1 transition-all duration-300 border"
      >
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-sm font-medium uppercase">{title}</CardTitle>
          <Icon className="h-5 w-5 text-muted-foreground" />
        </CardHeader>

        <CardContent>
          <div className="text-3xl font-bold">{displayValue}</div>

          <div className="mt-2 text-xs text-muted-foreground space-y-1">
            {/* <div>Total Size: {formatBytes(totalSize)}</div> */}
            {latestUpload && <div>Last Upload: {new Date(latestUpload).toLocaleDateString()}</div>}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
